import React, { useRef } from "react";
import { useTwitchMessage } from "../context/TwitchContext";

const TwitchChat = () => {
  const chatRef = useRef(null);

  useTwitchMessage((data) => {
    const { tags, message } = data;

    const username = tags["display-name"];
    const color = tags.color || "#fff";

    const badges = tags.badges
      ? Object.entries(tags.badges)
          .map(([badge]) => {
            if (badge === "moderator") {
              return `<img src="https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/1" width="20" height="20" alt="${badge}" />`;
            } else if (badge === "subscriber") {
              return `<img src="https://static-cdn.jtvnw.net/badges/v1/6575022e-d26e-4c83-90e2-9d7d94a32df6/3" width="20" height="20" alt="${badge}" />`;
            } else if (badge === "vip") {
              return `<img src="https://static-cdn.jtvnw.net/badges/v1/b817aba4-fad8-49e2-b88a-7cc744dfa6ec/3" width="20" height="20" alt="${badge}" />`;
            } else {
              return "";
            }
          })
          .join("")
      : "";

    // Replace emote codes with image tags
    let enrichedMessage = message;
    if (tags.emotes) {
      const emotePositions = Object.entries(tags.emotes).flatMap(
        ([emoteId, positions]) =>
          positions.map((position) => {
            const [start, end] = position.split("-");
            return { start: parseInt(start), end: parseInt(end), emoteId };
          })
      );

      // Sort emote positions by start index
      emotePositions.sort((a, b) => a.start - b.start);

      let enrichedParts = [];
      let lastIndex = 0;

      emotePositions.forEach(({ start, end, emoteId }) => {
        // Add plain text before the emote
        enrichedParts.push(enrichedMessage.slice(lastIndex, start));

        // Add emote image
        const emoteCode = enrichedMessage.slice(start, end + 1);
        enrichedParts.push(
          `<img src="https://static-cdn.jtvnw.net/emoticons/v1/${emoteId}/1.0" alt="${emoteCode}" class="inline-emote" />`
        );

        // Update the last processed index
        lastIndex = end + 1;
      });

      // Add remaining text after the last emote
      enrichedParts.push(enrichedMessage.slice(lastIndex));
      enrichedMessage = enrichedParts.join("");
    }

    // Append the new message to the chat container
    if (chatRef.current) {
      const messageElement = document.createElement("p");
      messageElement.dataset.msgId = `${tags["id"]}`;
      messageElement.className =
        "msg flex flex-wrap items-center mt-3 animate-message align-middle";
      messageElement.innerHTML = `
        <span style="color: ${color}" class="username flex flex-wrap items-center gap-1">
          <span class="inline-flex flex-wrap items-center gap-1">${badges}</span>
          <strong>${username}: </strong>
          <span class="text-white flex flex-wrap">${enrichedMessage}</span>
        </span>
      `;
      chatRef.current.appendChild(messageElement);

      // Remove the animation class after animation ends
      messageElement.addEventListener("animationend", () => {
        messageElement.classList.remove("animate-message");
      });
    }
  });

  return <div className="chatek" ref={chatRef}></div>;
};

export default TwitchChat;
